"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUpload = FileUpload;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("react");
function UploadIcon() {
    return ((0, jsx_runtime_1.jsx)("svg", { className: "h-10 w-10 text-default-400", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: (0, jsx_runtime_1.jsx)("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" }) }));
}
function FileIcon() {
    return ((0, jsx_runtime_1.jsx)("svg", { className: "h-6 w-6 text-primary", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: (0, jsx_runtime_1.jsx)("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" }) }));
}
function FileUpload(props) {
    var _a = props.accept, accept = _a === void 0 ? ".csv" : _a, _b = props.maxSize, maxSize = _b === void 0 ? 10 : _b, // 10MB default
    onFileSelect = props.onFileSelect, _c = props.isUploading, isUploading = _c === void 0 ? false : _c, _d = props.isDisabled, isDisabled = _d === void 0 ? false : _d, _e = props.uploadProgress, uploadProgress = _e === void 0 ? 0 : _e, error = props.error;
    var inputRef = (0, react_2.useRef)(null);
    var _f = (0, react_2.useState)(false), isDragOver = _f[0], setIsDragOver = _f[1];
    var _g = (0, react_2.useState)(null), selectedFile = _g[0], setSelectedFile = _g[1];
    var _h = (0, react_2.useState)(null), localError = _h[0], setLocalError = _h[1];
    var handleDragOver = function (e) {
        e.preventDefault();
        setIsDragOver(true);
    };
    var handleDragLeave = function (e) {
        e.preventDefault();
        setIsDragOver(false);
    };
    var validateFile = function (file) {
        var _a;
        setLocalError(null);
        // Check file type
        if (accept) {
            var acceptedTypes = accept.split(",").map(function (t) { return t.trim(); });
            var fileExtension_1 = ".".concat((_a = file.name.split(".").pop()) === null || _a === void 0 ? void 0 : _a.toLowerCase());
            if (!acceptedTypes.some(function (t) { return t === fileExtension_1 || t === file.type; })) {
                setLocalError("Invalid file type. Accepted: ".concat(accept));
                return false;
            }
        }
        // Check file size
        if (file.size > maxSize * 1024 * 1024) {
            setLocalError("File size exceeds ".concat(maxSize, "MB limit"));
            return false;
        }
        return true;
    };
    var handleFile = function (file) {
        if (validateFile(file)) {
            setSelectedFile(file);
            onFileSelect(file);
        }
    };
    var handleDrop = function (e) {
        e.preventDefault();
        setIsDragOver(false);
        var file = e.dataTransfer.files[0];
        if (file) {
            handleFile(file);
        }
    };
    var handleChange = function (e) {
        var _a;
        var file = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0];
        if (file) {
            handleFile(file);
        }
    };
    var handleClick = function () {
        var _a;
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    };
    var handleRemove = function () {
        setSelectedFile(null);
        setLocalError(null);
        if (inputRef.current) {
            inputRef.current.value = "";
        }
    };
    var displayError = error || localError;
    return ((0, jsx_runtime_1.jsxs)("div", { className: "w-full", children: [(0, jsx_runtime_1.jsx)("input", { ref: inputRef, type: "file", accept: accept, onChange: handleChange, className: "hidden", disabled: isUploading || isDisabled }), !selectedFile ? ((0, jsx_runtime_1.jsxs)("div", { onDragOver: handleDragOver, onDragLeave: handleDragLeave, onDrop: handleDrop, onClick: handleClick, className: "flex cursor-pointer flex-col items-center justify-center rounded-lg border-2 border-dashed p-8 transition-colors ".concat(isDragOver
                    ? "border-primary bg-primary/10"
                    : "border-default-300 hover:border-primary hover:bg-default-100"), children: [(0, jsx_runtime_1.jsx)(UploadIcon, {}), (0, jsx_runtime_1.jsx)("p", { className: "mt-4 text-sm font-medium text-foreground", children: "Drag and drop your file here, or click to browse" }), (0, jsx_runtime_1.jsxs)("p", { className: "mt-1 text-xs text-default-500", children: ["Accepted formats: ", accept, " (Max ", maxSize, "MB)"] })] })) : ((0, jsx_runtime_1.jsxs)("div", { className: "rounded-lg border border-default-200 p-4", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-3", children: [(0, jsx_runtime_1.jsx)(FileIcon, {}), (0, jsx_runtime_1.jsxs)("div", { className: "flex-1 min-w-0", children: [(0, jsx_runtime_1.jsx)("p", { className: "truncate text-sm font-medium text-foreground", children: selectedFile.name }), (0, jsx_runtime_1.jsxs)("p", { className: "text-xs text-default-500", children: [(selectedFile.size / 1024).toFixed(2), " KB"] })] }), !isUploading && !isDisabled && ((0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", variant: "light", color: "danger", onPress: handleRemove, children: "Remove" }))] }), isUploading && ((0, jsx_runtime_1.jsx)(react_1.Progress, { "aria-label": "Uploading...", size: "sm", value: uploadProgress, className: "mt-3", color: "primary" }))] })), displayError && ((0, jsx_runtime_1.jsx)("p", { className: "mt-2 text-sm text-danger", children: displayError }))] }));
}
